import apiClient from "../../../api/apiClient";
import { UnifiedResponse } from "../../../models/Response/unifiedResponse";
import { localStorageService } from "../../../services/localStorageService";
import {
  LoginRequest,
  LoginResponse,
  SetBannerRequest,
  BannerImageResponse,
} from "../models";

export const authApi = {
  login: async (
    data: LoginRequest,
  ): Promise<UnifiedResponse<LoginResponse>> => {
    const response = await apiClient.post<UnifiedResponse<LoginResponse>>(
      `/account/login`,
      data,
      {
        headers: {
          requiresAuth: false,
        },
      },
    );

    return response.data;
  },

  signUp: async (data: any): Promise<UnifiedResponse<LoginResponse>> => {
    const response = await apiClient.post<UnifiedResponse<LoginResponse>>(
      `/account/signup`,
      data,
      {
        headers: {
          requiresAuth: false,
        },
      },
    );
    return response.data;
  },

  oneClickSignup: async (
    data: any,
  ): Promise<UnifiedResponse<LoginResponse>> => {
    const response = await apiClient.post<UnifiedResponse<LoginResponse>>(
      `/account/get_oneclick_registration_info`,
      data,
      {
        headers: {
          requiresAuth: false,
        },
      },
    );
    return response.data;
  },

  sendOneClickSignupDetails: async (
    data: any,
  ): Promise<UnifiedResponse<any>> => {
    const response = await apiClient.post<UnifiedResponse<any>>(
      `/account/send_oneclick_registration_notification`,
      data,
      {
        headers: {
          requiresAuth: false,
        },
      },
    );
    return response.data;
  },

  forgotPassword: async (
    username: string,
    notificationData: any,
    isNotificationSendOnEmail: boolean,
  ): Promise<UnifiedResponse<any>> => {
    const response = await apiClient.post<UnifiedResponse<any>>(
      "/account/forgot_password",
      {
        username,
        notificationData,
        isNotificationSendOnEmail,
      },
      {
        headers: {
          requiresAuth: false,
        },
      },
    );
    return response.data;
  },

  verifyForgotPasswordCode: async (
    code: string,
  ): Promise<UnifiedResponse<any>> => {
    const response = await apiClient.post<UnifiedResponse<any>>(
      "/account/verify_password",
      {
        otp: code,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorageService.getItem("resetToken")}`,
        },
      },
    );
    return response.data;
  },

  logout: async (): Promise<UnifiedResponse<any>> => {
    const response =
      await apiClient.get<UnifiedResponse<any>>(`/account/logout`);
    return response.data;
  },

  updatePasswordChangeOneClick: async (): Promise<void> => {
    await apiClient.post<UnifiedResponse<any>>(
      "/users/updatePasswordChangeOneClick",
    );
  },

  retrieveBanners: async (
    data: SetBannerRequest,
  ): Promise<UnifiedResponse<BannerImageResponse>> => {
    const response = await apiClient.post<UnifiedResponse<BannerImageResponse>>(
      "/banner/retrieve",
      data,
      {
        headers: {
          requiresAuth: false,
        },
      },
    );
    return response.data;
  },
};
